import { motion } from "framer-motion";
import { ArrowRight, Phone, Mail, ExternalLink } from "lucide-react";

const fadeInUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
};

export function CTASection() {
  return (
    <section id="contact" className="py-14 sm:py-20 lg:py-28 bg-white">
      <div className="container">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <motion.div {...fadeInUp} transition={{ duration: 0.6 }} className="text-center mb-8 sm:mb-12">
            <div className="flex items-center justify-center gap-3 sm:gap-4 mb-4 sm:mb-6">
              <div className="w-8 sm:w-12 h-px bg-[#E0E0E0]" />
              <span className="text-[10px] sm:text-xs font-medium tracking-widest uppercase text-[#666666]" style={{ fontFamily: "'Inter', sans-serif" }}>
                Contact
              </span>
              <div className="w-8 sm:w-12 h-px bg-[#E0E0E0]" />
            </div>
            <h2 className="text-xl sm:text-2xl lg:text-4xl font-bold text-[#1A1A1A] mb-3 sm:mb-4">
              まずは無料相談から
            </h2>
            <p className="text-sm sm:text-base text-[#333333] leading-relaxed">
              「何から始めればいいか分からない」——その一言から、一緒に考えます。
              <br className="hidden sm:block" />
              現場の課題をお聞かせください。最適な解決策をご提案します。
            </p>
          </motion.div>

          {/* CTA Card */}
          <motion.div
            {...fadeInUp}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="bg-[#F9F9F9] border border-[#E0E0E0] p-5 sm:p-8 lg:p-12"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6 mb-6 sm:mb-8">
              {/* Phone */}
              <a
                href="tel:05050521301"
                className="flex items-center gap-3 sm:gap-4 p-4 bg-white border border-[#E0E0E0] hover:border-[#E03030] transition-colors active:scale-[0.98] touch-manipulation"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-[#1A1A1A] text-white rounded-sm shrink-0">
                  <Phone size={18} strokeWidth={1.5} />
                </div>
                <div>
                  <div className="text-[10px] sm:text-xs text-[#666666] mb-0.5">お電話でのご相談</div>
                  <span className="text-base sm:text-lg font-bold text-[#1A1A1A]" style={{ fontFamily: "'Inter', sans-serif" }}>
                    050-5052-1301
                  </span>
                </div>
              </a>

              {/* Email */}
              <a
                href="mailto:81@eightone.co"
                className="flex items-center gap-3 sm:gap-4 p-4 bg-white border border-[#E0E0E0] hover:border-[#E03030] transition-colors active:scale-[0.98] touch-manipulation"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-[#1A1A1A] text-white rounded-sm shrink-0">
                  <Mail size={18} strokeWidth={1.5} />
                </div>
                <div>
                  <div className="text-[10px] sm:text-xs text-[#666666] mb-0.5">メールでのご相談</div>
                  <span className="text-sm sm:text-base font-bold text-[#1A1A1A]">
                    81@eightone.co
                  </span>
                </div>
              </a>
            </div>

            {/* Main CTA Button */}
            <a
              href="https://eightone.co/#contact"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full inline-flex items-center justify-center gap-2 sm:gap-3 px-6 sm:px-8 py-4 sm:py-5 bg-[#E03030] text-white font-bold text-sm sm:text-base rounded hover:bg-[#c72828] transition-colors duration-200 active:scale-[0.98] touch-manipulation"
            >
              無料・現場DX診断を予約する
              <ExternalLink size={16} />
            </a>

            <p className="text-[10px] sm:text-xs text-[#666666] text-center mt-3 sm:mt-4">
              所要時間：約60分 / オンライン対応可 / 秘密厳守
            </p>
          </motion.div>

          {/* Trust */}
          <motion.div
            {...fadeInUp}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="mt-6 sm:mt-8 text-center"
          >
            <p className="text-[10px] sm:text-xs text-[#666666]">
              81合同会社｜広島・大阪・東京を拠点に全国対応
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
